import React, { useCallback, useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";

import {
  featuredJobs,
  formatEducationRequired,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import {
  Box,
  Card,
  CardContent,
  Chip,
  IconButton,
  Typography,
  TextField,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import { useLocation, useNavigate } from "react-router-dom";
import PostJobDetail from "../../components/popUp/PostJobDetail";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import PostJobModal from "../../components/popUp/PostJobPopUp";
import RecordNotFound from "../../components/recordNotFound/RecordNotFound";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import { useIds } from "../../hook/AdminContext";
import { useSnackbar } from "notistack";
import {
  _get_JD_list_blog_api,
  _get_job_feed_list_blog_api,
  delete_live_job_feed_api,
  favourite_live_job_api,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import PageLoading from "../../components/loader/PageLoading";
import CustomConfirmation from "../../components/popUp/CustomConfirmation";
import CustomPopoverSection from "../../components/menu/MebuCustomPopOverSection";
import { s3baseUri } from "../../config/config";
import moment from "moment";
import SkeletonFavoiriteJobs from "../loader/FavouriteJobSkeleton";
import CompanyPopup from "../popUp/CompanyPopup";
import JobFeedList from "../../pages/liveJobFeed/JobFeedList";
import { get_favourites_job_api } from "../../DAL/jobs/jobs";
import CustomPopoverNew from "../CustomPopoverNew";
import SharePostPopup from "../cards/SharePostPopup";
import CustomModalLayout from "../modal/CustomModalLayout";

export default function FavouriteJobs() {
  const navigate = useNavigate();
  const {
    findId,
    setBreadCrumb,
    userInfo,
    activeSourceList,
    handleReportPost,
    setUpdateJobOnNotification,
  } = useIds();
  const [searchInputValue, setSearchInputValue] = useState("");
  let data_array = activeSourceList;

  const location = useLocation();
  const filteredData =
    userInfo?.role === "client"
      ? data_array?.filter((item) =>
          userInfo?.source?.some((source) => source?.source_id === item._id)
        )
      : data_array;

  const firstSegment = location.pathname.split("/")[1];
  const { enqueueSnackbar } = useSnackbar();
  const observer = useRef();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [openDetail, setOpenDetail] = useState(false);
  const [cv, setCv] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);
  const [sourceId, setsourceId] = useState(null);
  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const isTablet = useMediaQuery("(max-width:768px)");
  const formatSalaryFrequency = (frequency) => {
    switch (frequency) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };

  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const [partnersObj, setPartnersObj] = useState({});
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deletingMemberId, setDeletingMemberId] = useState("");

  const [totalPages, setTotalPages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);

  const [page, setPage] = useState(0);

  const [loadMorePath, setLoadMorePath] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [searchText, setSearchText] = useState("");

  const [editMode, setEditMode] = useState(false);
  const [membersList, setMembersList] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedFilter, setSelectedFilter] = useState(
    filteredData[0]?.source_slug || ""
  );
  const [filter, setfilter] = useState("");
  // share job State
  const [openSharePost, setOpenSharePost] = useState(null);
  const limit_per_page = 50;
  const load_more_path =
    "api/jobs/favorite_job_list?page=0&limit=" + limit_per_page;
  let icon = {
    iconBg: "var(--portal-primary-color)",
  };
  const handleNavigateAppliedJobs = () => {
    navigate(`/favourite-jobs/applied-jobs`, { state: { routePath: "home" } });
  };

  const handleOpenDetail = (job) => {
    navigate(`/favourite-jobs/detail/${job?.job_slug}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const handleCandidates = (job) => {
    navigate(`/favourite-jobs/candidates/${job._id}`, {
      state: { job },
      topic: featuredJobs,
    });
  };
  const fetchCategories = async (path, search, loading, pagination_type) => {
    if (!loading) {
      setLoading(true);
      path = load_more_path;
    }
    if (!path) {
      path = load_more_path;
    }
    const is_multi_page = pagination_type === "multi_page";
    if (is_multi_page) {
      setLoading(true);
    }

    const response = await get_favourites_job_api(selectedFilter, search, path);
    for (let i = 0; i < response.jobs?.length; i++) {
      for (let j = 0; j < response?.jobs[i].job_applicants?.length; j++) {
        if (user_info?._id === response.jobs[i]?.job_applicants[j]?.userId) {
          response.jobs[i].created_by_me = true;
        }
      }
    }

    if (response.code === 200) {
      setLoadMorePath(response.load_more_url);
      setTotalPages(response.total_pages);
      setsourceId(response.created_for);

      // Filter out any undefined/null jobs to prevent _id errors
      const validJobs =
        response.jobs?.map((job) => {
          return { ...job, is_favourite: true };
        }) || [];

      if (loading || is_multi_page) {
        let new_array = categories.concat(validJobs);
        if (is_multi_page) {
          setCategories(response.jobs);
        } else {
          setCategories(new_array);
          setPageNumber((prev) => prev + 1);
        }
      } else {
        setCategories(validJobs);
        setPageNumber(1);
      }
      setPartnersObj(validJobs);
      setLoading(false);
      setIsLoadingMore(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsLoadingMore(false);
    }
  };

  const loadMoreData = (pagination_type, value) => {
    setPageNumber(value);
    setIsLoadingMore(true);
    const custom_path = `api/jobs/favorite_job_list?page=${
      value - 1
    }&limit=${limit_per_page}`;
    fetchCategories(custom_path, searchInputValue, true, pagination_type);
  };

  let login_nfo = localStorage.getItem("user");
  let user_info = login_nfo ? JSON.parse(login_nfo) : null;
  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totalPages >= pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totalPages, pageNumber, loadMorePath, observer]
  );
  useEffect(() => {
    if (!loading) {
      const timeoutId = setTimeout(() => {
        fetchCategories(loadMorePath, searchInputValue, false);
      }, 800);
      return () => clearTimeout(timeoutId);
    }
  }, [searchInputValue]);

  useEffect(() => {
    fetchCategories(load_more_path, searchInputValue, false);
  }, [selectedFilter]);
  const handleCompanyNameClick = (Job, e) => {
    e.preventDefault();
    e.stopPropagation();
    setCompanyModalData(Job?.creater_info);
    setCompanyModalOpen(true);
  };

  useEffect(() => {
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },
    ]);
  }, []);
  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);

  // share post state and functions
  const handleOpenSharePost = (job) => {
    setSelectedJob(job);
    setOpenSharePost(true);
  };

  const MENU_OPTIONS = (job) => {
    if (job?.created_by?._id === userInfo?.profile_id) {
      let optionsArray = [];

      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.update &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Edit",
          icon: "akar-icons:edit",
          handleClick(row) {
            handleOpenEditJob(row);
          },
        });
      }

      optionsArray.push({
        label: "Share Job",
        icon: "mdi:share-outline",
        handleClick: (row) => {
          handleOpenSharePost(row);
        },
      });
      if (
        (userInfo?.role == "client" && !userInfo?.isCompanyProfile) ||
        (userInfo?.isCompanyProfile &&
          userInfo?.company_access?.job?.delete &&
          (userInfo?._id == job?.action_by?._id ||
            userInfo?.company_access?.job?.global_access))
      ) {
        optionsArray.push({
          label: "Delete",
          icon: "ant-design:delete-twotone",
          handleClick: (row, index) => handleDelete(row), // Pass complete row instead of row._id
        });
      }

      return optionsArray;
    } else {
      return [
        {
          label: "Share Job",
          icon: "mdi:share-outline",
          handleClick: (row) => {
            handleOpenSharePost(row);
          },
        },
        {
          label: "Report Job",
          icon: "material-symbols:report-outline",
          handleClick: (row, index) => handleNavigateReportJob(row),
          color: "error",
        },
      ];
    }
  };

  const handleNavigateReportJob = (job) => {
    // navigate(`/home/report/job/${job._id}`, {
    //   state: {
    //     backURL: `/favourite-jobs`,
    //   },
    // });
    handleReportPost(job, "job", handleFilterJob);
  };

  const handleFilterJob = (id) => {
    setCategories((prev) => prev.filter((item) => item._id !== id));
  };
  const handleCloseDetail = () => {
    setOpenDetail(false);
    setCv(null);
  };

  const handleBookmarkToggle = (jobId) => {
    const newBookmarkedState = !bookmarkedJobs[jobId];

    setBookmarkedJobs((prev) => {
      const updatedBookmarks = { ...prev, [jobId]: newBookmarkedState };
      localStorage.setItem("bookmarkedJobs", JSON.stringify(updatedBookmarks));
      return updatedBookmarks;
    });

    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        const successMessage = newBookmarkedState
          ? "Job added to favorites"
          : "Job removed from favorites";

        enqueueSnackbar(successMessage, { variant: "success" });
        fetchCategories(load_more_path, searchInputValue, false);
      })
      .catch((error) => {
        console.error("Error updating favorite job:", error);

        // Revert state in case of API failure
        setBookmarkedJobs((prev) => {
          const revertedBookmarks = { ...prev, [jobId]: !newBookmarkedState };
          localStorage.setItem(
            "bookmarkedJobs",
            JSON.stringify(revertedBookmarks)
          );
          return revertedBookmarks;
        });

        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handlePersonalJob = () => {
    navigate(`/${firstSegment}/live-job-feed/personal-jobs`);
  };

  const handleClose = () => {
    setEditMode(false);
    setSelectedJob(null);
    // setfilter(selectedFilter);

    setOpen(false);
  };
  const handleOpenEditJob = (job) => {
    // setEditMode(true);
    // setSelectedJob(job);
    // setOpen(true);
    navigate(`/${job.source.slug}/edit-job/${job.job_slug}`, {
      state: { job },
    });
  };
  const handleDeleteMember = async (id) => {
    // ID as parameter lein
    setLoading(true);

    const response = await delete_live_job_feed_api(id);
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      fetchCategories(load_more_path, searchInputValue, false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
    }
    setDeleteLoading(false);
    setDeleteDialogOpen(false);
  };
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchInputValue(value);
  };

  const handleDelete = (row) => {
    setDeletingMemberId(row.job_slug);
    setDeleteDialogOpen(true);
  };
  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
  };
  const renderFilterChips = () => {};
  const appliedFilters = () => {};
  const handleFilterClear = () => {};

  const handleFilterChange = (event) => {
    const selectedId = event.target.value;
    setSelectedFilter(selectedId);
  };
  const handleUpdateSpecificJob = (updatedJob, setList = setCategories) => {
    console.log("updated data", updatedJob);
    if (updatedJob.deleted_job_id) {
      setList((prev) =>
        prev.filter((item) => item._id != updatedJob.deleted_job_id)
      );
      return;
    }
    setList((prev) =>
      prev.map((item) =>
        item._id === updatedJob._id ? { ...item, ...updatedJob } : item
      )
    );
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setCategories);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [categories]);
  return (
    <>
      <JobFeedList
        isTablet={isTablet}
        categories={categories}
        setCategories={setCategories}
        loading={loading}
        appliedFilters={appliedFilters}
        handleFilterClear={handleFilterClear}
        lastBookElementRef={lastBookElementRef}
        loadMoreData={loadMoreData}
        isLoadingMore={isLoadingMore}
        totalPages={totalPages}
        pageNumber={pageNumber}
        handleOpenDetail={handleOpenDetail}
        handleCompanyNameClick={handleCompanyNameClick}
        s3baseUri={s3baseUri}
        bookmarkedJobs={bookmarkedJobs}
        handleBookmarkToggle={handleBookmarkToggle}
        MENU_OPTIONS={MENU_OPTIONS}
        handlePersonalJob={handlePersonalJob}
        handleOpen={handleOpen}
        // filterDrawerOpen={filterDrawerOpen}
        // handleFilterDrawerClose={handleFilterDrawerClose}
        fetchCategories={fetchCategories}
        handleFilterChange={handleFilterChange}
        // handleRemoveFilterChip={handleRemoveFilterChip}
        companyModalOpen={companyModalOpen}
        handleCloseCompanyModal={handleCloseCompanyModal}
        companyModalData={companyModalData}
        openDetail={openDetail}
        cv={cv}
        selectedJob={selectedJob}
        setCv={setCv}
        handleCloseDetail={handleCloseDetail}
        open={open}
        handleClose={handleClose}
        editMode={editMode}
        sourceId={sourceId}
        load_more_path={load_more_path}
        findId={findId}
        searchTerm={searchInputValue}
        show_des_data={show_des_data}
        handleCandidates={handleCandidates}
        deleteDialogOpen={deleteDialogOpen}
        handleDeleteMember={handleDeleteMember}
        setDeleteDialogOpen={setDeleteDialogOpen}
        deletingMemberId={deletingMemberId}
        pageTitle={"Favourite Jobs"}
        isMyJobPost={true}
        userInfo={userInfo}
        renderFilterChips={renderFilterChips}
        setIsHovered={false}
        handleInputChange={handleInputChange}
        isFavourite={true}
        filteredData={filteredData}
        selectedFilter={selectedFilter}
        setSelectedFilterFav={setSelectedFilter}
        selectedFilterFav={selectedFilter}
      />

      {openSharePost && (
        <CustomModalLayout
          open={openSharePost}
          onClose={() => setOpenSharePost(false)}
          title="Share Job"
          width="550px"
          componentToPass={
            <SharePostPopup
              postData={{
                ...selectedJob,
                _id: selectedJob.job_slug,
                description: selectedJob.job_title,
              }}
              type={"job"}
            />
          }
        />
      )}
    </>
  );
}
